import React from "react";

function Blog() {
  return (
    <section className="section section--blog section--blog-bg --section-normal-tb-padding">
      <div className="container">
        <div className="container__row --flex-center">
          <div className="container__col-md-6 --section-large-tb-padding">
            <p className="container__sub-heading">BLOG</p>
            <h2 className="container__heading">
              Amazon Vs Branded Commerce <br />
              Experiences: Pros and Cons
            </h2>
            <p className="container__content --italic">
              “We will take a look at the differences between Amazon and your
              own ecommerce channels and how to leverage your brand strengths to
              maximize customer satisfaction and sales.”
            </p>
            <p className="container__content">
              {/* #E-COMMERCE, #WEB DEVELOPMENT, #MARKETING */}
            </p>
            <a
              className="--action-link"
              href="/blog/Amazon-Vs-Branded-Commerce-Experiences-Pros-and-Cons"
              target="_blank"
            >
              Read BLOG
            </a>
          </div>
          <div className="container__col-md-6 --flex-center">
            <img
              src="../../solutions/solutions/amazon-vs-commerce.png"
              alt="Amazon Vs Branded Commerce"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
export default Blog;
